import { useDispatch, useSelector } from "react-redux";
import { useEffect } from 'react';
import { Logger } from '@utils/logger';
import { getTMXIDWJS, getTmxInDCUI, getTMXOrgId, getTMXPageId, getTMXProfilingDomain, getTMXSessionId } from '@redux/selectors/verification-configuration-selectors';
import { setTmxLoadError, setTmxProfilingIsCompleted } from "@redux/actions/tmx-actions";
import { getCaptureStarted, getVerificationStepConfig } from "@redux/selectors/verification-step-config-selectors";
import { loadScript } from "@utils/script-util";

declare global {
    interface Window {
        tmx_profiling_complete: () => void;
        idwtmx: {
            profile: (tmxProfilingDomain: string, tmxOrgID: string, tmxSessionID: string, tmxPageID: string) => void;
        }
    }
}

export const useTmx = () => {
    const dispatch = useDispatch();
    const verificationStepConfig = useSelector(getVerificationStepConfig);
    const tmxProfilingDomain = useSelector(getTMXProfilingDomain);
    const tmxInDCUI = useSelector(getTmxInDCUI);
    const tmxOrgID = useSelector(getTMXOrgId);
    const tmxPageID = useSelector(getTMXPageId);
    const tmxSessionID = useSelector(getTMXSessionId);
    const tmxIDWJS = useSelector(getTMXIDWJS);
    const captureStarted = useSelector(getCaptureStarted);

    const onTmxProfilingComplete = () => {
        dispatch(setTmxProfilingIsCompleted(true));
    };

    const onTmxLoadError = (error: string) => {
        dispatch(setTmxLoadError(error));
    };

    const initializeTMX = () => {
        try {
            loadScript(tmxIDWJS, 'tmxIDWJS', onTmxLoaded);
        } catch (error) {
            onTMXError(error);
        }
    }

    const onTMXError = (error: string) => {
        console.error(error);
        onTmxLoadError(error);
        Logger.error("[TMX] script load error")
    }

    const onTmxLoaded = (loaded: boolean) => {
        if (loaded) {
            window.tmx_profiling_complete = onTmxProfilingComplete;
            window.idwtmx.profile(tmxProfilingDomain, tmxOrgID, tmxSessionID, tmxPageID);
            Logger.info('[TMX] Loaded the TMX script');
        }

    }

    useEffect(() => {
        if (verificationStepConfig.initialized && tmxInDCUI && captureStarted) {
            if (tmxIDWJS) {
                initializeTMX();
            } else {
                onTMXError('TMX is not configured correctly');
            }
        }
    }, [verificationStepConfig.initialized, tmxInDCUI, captureStarted, tmxIDWJS]);
}